import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { CardTitle } from '@/components/ui/card';
    import { columns } from '@/tables/columns/credit-cards';
    import { computed } from 'vue';
    import { handleQueryRetry } from '@/utils/helpers';
    import { Head } from '@inertiajs/vue3';
    import { usePage } from '@inertiajs/vue3';
    import { useQuery } from '@tanstack/vue-query';
    import AppLayout from '@/layouts/AppLayout.vue';
    import axios from 'axios';
    import CreateCreditCard from '@/components/credit-cards/CreateCreditCard.vue';
    import DataTable from '@/components/datatable/DataTable.vue';
    import DataTableToolbarActions from '@/components/datatable/DataTableToolbarActions.vue';
    import PageCard from '@/components/PageCard.vue';
    import QueryKey from '@/enums/QueryKey';
    import type { SharedData, BreadcrumbItem } from '@/types';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'CreditCards',
  setup(__props) {

    const page = usePage<SharedData>();
    const selectedCompanyId = computed(() => page.props.auth.user.selected_company_id);

    const breadcrumbs: BreadcrumbItem[] = [
        {
            title: 'menu.administration',
        },
        {
            title: 'menu.credit_cards',
        },
    ];

    const { isPending, data } = useQuery({
        queryKey: [QueryKey.CREDIT_CARDS, selectedCompanyId],
        queryFn: getCreditCards,
        retry: handleQueryRetry,
    });

    async function getCreditCards() {
        const { data } = await axios.get(
            route('v2.credit-cards.table', { company: selectedCompanyId.value }),
        );
        return data.data;
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(Head), {
      title: _ctx.$t('credit-cards.page_header')
    }, null, 8, ["title"]),
    _createVNode(AppLayout, {
      breadcrumbs: breadcrumbs,
      "require-selected-company": ""
    }, {
      default: _withCtx(() => [
        _createVNode(PageCard, null, {
          default: _withCtx(() => [
            _createVNode(DataTable, {
              "table-key": _unref(QueryKey).CREDIT_CARDS,
              columns: _unref(columns),
              data: _unref(data),
              loading: _unref(isPending),
              "default-sorting": [
                    {
                        id: 'name',
                        desc: false,
                    },
                ]
            }, {
              title: _withCtx(() => [
                _createVNode(_unref(CardTitle), null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('credit-cards.page_header')), 1)
                  ]),
                  _: 1
                })
              ]),
              actions: _withCtx(() => [
                _createVNode(DataTableToolbarActions, { name: "credit-cards" }, {
                  default: _withCtx(() => [
                    _createVNode(CreateCreditCard)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["table-key", "columns", "data", "loading"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}
}

})